import { Font, StyleSheet } from '@react-pdf/renderer';
import LatoSemibold from '../../../fonts/Lato-Semibold.ttf';
import LatoBold from '../../../fonts/Lato-Bold.ttf';
import Lato from '../../../fonts/Lato-Regular.ttf';

Font.register({
    family: 'Lato',
    fonts: [
        {
            src: Lato,
        },
        {
            src: Lato,
            fontWeight: '400'
        },
        {
            src: LatoBold,
            fontWeight: 'bold',
        },
        {
            src: LatoSemibold,
            fontWeight: '500',
        },
    ],
});

const ArticlePrintStyle = StyleSheet.create({
    page: {
        padding: "16px",
    },

    title: {
        position: "absolute",
        bottom: "40px",
        fontSize: "28px",
        color: "#FFF",
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
        fontFamily: "Lato"
    },

    titleShadow: {
        position: "absolute",
        bottom: "38px",
        left: "2px",
        fontSize: "28px",
        color: "#000",
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
        fontFamily: "Lato"
    },

    subtitle: {
        position: "absolute",
        bottom: "16px",
        fontSize: "14px",
        color: "#FFF",
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
        textDecoration: "underline",
        fontFamily: "Lato"
    },

    subtitleShadow: {
        position: "absolute",
        bottom: "15px",
        left: "1px",
        fontSize: "14px",
        color: "#000",
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
        textDecoration: "underline",
        fontFamily: "Lato"
    },

    textContent: {
        paddingTop: "16px",
        paddingBottom: "16px",
        fontSize: "12px",
    },

    heading: {
        marginBottom: "16px",
        height: "32px",
    },

    headingItem: {
        position: "absolute",
        top: "0px",
        display: "inline",
        width: "33.33333%",
        textAlign: "center"
    },

    headingText: {
        fontSize: "12px",
        marginTop: "3px",
        fontFamily: "Lato"
    },

    perex: {
        fontWeight: "500",
        fontFamily: "Lato"
    },

    component: {
        marginTop: "4px",
        marginBottom: "16px"
    },

    listItem: {
        marginTop: "8px",
        fontFamily: "Lato"
    },

    imageList: {
        position: "absolute",
        backgroundColor: "#111",
        width: "180px",
        height: "140px",
        objectFit: "contain",
        borderRadius: "8px"
    },

    simpleImage: {
        width: "500px",
        marginLeft: "36px"
    }
});

export default ArticlePrintStyle;